
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/guide/[id]/echo/[echoId]",
      function () {
        return require("private-next-pages/game/guide/[id]/echo/[echoId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game/guide/[id]/echo/[echoId]"])
      });
    }
  